var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-item",attrs:{"draggable":"true"},on:{"dragstart":_vm.handleDragStart,"drag":_vm.handleDrag,"dblclick":_vm.handleInsert}},[_vm._v("\n  "+_vm._s(_vm.value.label || _vm.value.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }